export const cycloidDefault = {
  credentials: [
    'cycloid-worker-keys',
    'vault',
  ],
  roles: [
    'organization-admin',
    'organization-member',
  ],
}

export const AVAILABLE = {
  apiKeys: [],
  appearances: [],
  catalogRepositories: [],
  childOrgs: [],
  cloudProviders: [],
  components: [],
  configRepositories: [],
  credentials: [],
  environmentComponents: [],
  environments: [],
  environmentTypes: [],
  events: [],
  externalBackends: [],
  infraPolicies: [],
  inventoryResources: [],
  invitedMembers: [],
  invites: [],
  KPIs: [],
  labels: [],
  members: [],
  pipelines: [],
  plugins: [],
  pluginManagers: [],
  pluginRegistries: [],
  policies: [],
  projects: [],
  resourceTypes: [],
  roles: [],
  stacks: [],
  stackVersionAdoption: [],
  versionsByStackRef: [],
  teamMembers: [],
  teams: [],
  workers: [],
  ssos: [],
}

export const FILTERS = {
  inventoryResources: {},
  KPIs: {
    datePeriod: {
      label: null,
      range: '1w',
      value: {
        begin: null,
        end: null,
      },
    },
    project: null,
  },
}
